import { blue } from "@faro-lotv/flat-ui";
import { Box, Stack } from "@mui/system";
import type { JSX } from "react";
import { CursorProps } from "react-arborist";

/**
 * @returns The line cursor shown when dragging an element inside a folder in the tree
 */
export function CaptureTreeDragCursor({
  top,
  left,
  indent,
}: CursorProps): JSX.Element {
  return (
    <Stack
      direction="row"
      sx={{ alignItems: "center" }}
      style={{
        zIndex: 1,
        position: "absolute",
        pointerEvents: "none",
        top: `${top - 2}px`,
        left: `${left}px`,
        right: `${indent}px`,
      }}
    >
      <Box
        component="div"
        style={{
          width: "4px",
          height: "4px",
          boxShadow: `0 0 0 3px ${blue[400]}`,
          borderRadius: "50%",
        }}
      />
      <Box
        component="div"
        style={{
          flex: 1,
          height: "2px",
          background: blue[400],
          borderRadius: "1px",
        }}
      />
    </Stack>
  );
}
